module.exports = __webpack_public_path__ + "img/poke_served.925db1ad.jpg";